import { BasicDeviceGroupData } from '@order-management/types';
import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { Element, Form, Icon } from 'react-bulma-components';
import {
  FaChevronLeft,
  FaFolder,
  FaFolderOpen,
  FaMagnifyingGlass,
} from 'react-icons/fa6';
import Button from '../../../ui/button/button';
import { MOVE_DEVICE_OPTIONS } from '../move-devices-modal';
import MoveDevicesOptionItem from '../move-devices-option-item/move-devices-option-item';
import styles from './move-devices-device-groups-layout.module.scss';

export type MoveDevicesDeviceGroupsLayoutProps = {
  deviceGroups: BasicDeviceGroupData[];
  selectedDeviceGroupId: string | undefined;
  handleSelectDeviceGroup: (id: string) => void;
  handleBackButtonClick: () => void;
};

export function MoveDevicesDeviceGroupsLayout({
  deviceGroups,
  selectedDeviceGroupId,
  handleSelectDeviceGroup,
  handleBackButtonClick,
}: MoveDevicesDeviceGroupsLayoutProps) {
  const [search, setSearch] = useState<string>('');

  const filteredDeviceGroups = useMemo(() => {
    if (search.trim() !== '') {
      return deviceGroups.filter((deviceGroup) =>
        deviceGroup.name.toLowerCase().includes(search.toLowerCase())
      );
    }
    return deviceGroups;
  }, [deviceGroups, search]);

  const onSearchChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  }, []);

  return (
    <>
      <Button
        className={'w-fit-content is-borderless'}
        onClick={handleBackButtonClick}
      >
        <Icon color="primary-dark">
          <FaChevronLeft />
        </Icon>
        <Icon color="primary-dark">
          <FaFolderOpen />
        </Icon>
        <span className="has-text-primary-dark">
          {MOVE_DEVICE_OPTIONS.DEVICE_GROUP}
        </span>
      </Button>
      <Element pl={8} pb={1}>
        <Form.Control>
          <Icon align="left">
            <FaMagnifyingGlass className={styles.searchIcon} />
          </Icon>
          <Form.Input
            className={styles.searchInput}
            aria-label="Search"
            placeholder="Search..."
            type="text"
            value={search}
            onChange={onSearchChange}
          />
        </Form.Control>
      </Element>
      <Element
        display="flex"
        flexDirection="column"
        pl={8}
        className={styles.scrollableContainer}
      >
        {filteredDeviceGroups.map((deviceGroup) => (
          <MoveDevicesOptionItem
            key={`${MOVE_DEVICE_OPTIONS.DEVICE_GROUP}-${deviceGroup.id}`}
            icon={<FaFolder />}
            label={deviceGroup.name}
            active={deviceGroup.id === selectedDeviceGroupId}
            onClick={() => handleSelectDeviceGroup(deviceGroup.id)}
          />
        ))}
      </Element>
    </>
  );
}

export default MoveDevicesDeviceGroupsLayout;
